import { useEffect, useRef, useState } from 'preact/hooks';
import { Link } from '../Link.tsx';
import { docsPages } from '../../pages/docs/docsNav.ts';
import { useT } from '../../i18n.ts';

export function LearnMoreMenu() {
  const t = useT();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onClick = (event: MouseEvent) => {
      const target = event.target;
      if (target instanceof Node && !ref.current?.contains(target)) setOpen(false);
    };
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  return (
    <div ref={ref} className={`learn-more-menu ${open ? 'is-open' : ''}`}>
      <button
        type="button"
        className="learn-more-trigger"
        aria-expanded={open}
        aria-haspopup="true"
        onClick={() => setOpen((o) => !o)}
      >
        {t('learn-more-menu.trigger')}
        <svg
          className="learn-more-chevron"
          viewBox="0 0 10 6"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M1 1l4 4 4-4"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      {open && (
        <div className="learn-more-panel" role="menu" data-gp-name="learn-more-menu">
          {docsPages.map((page) => (
            <Link
              key={page.path}
              to={page.path}
              className="learn-more-item"
              role="menuitem"
              onClick={() => setOpen(false)}
            >
              <span className="learn-more-item-title">{t(page.labelKey)}</span>
              <span className="learn-more-item-desc">{t(page.descKey)}</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
